import * as Entities from '@/shared/openapi-reniecyt-client/api';
import { AreaConocimiento, Domicilio, MiPerfil } from '@conacyt/perfil-usuario-client';
import { email } from 'vuelidate/lib/validators';
export default class EntityFactory {
  public static getDefaultCatalogo(): any {
    return {
      id: null,
      nombre: '',
    };
  }

  public static getDefaultCatalogoClave(): any {
    return {
      id: null,
      clave: null,
      nombre: '',
    };
  }

  public static getDefaultCatalogoClaveInstitucion(): any {
    return {
      //id: diez-mil para institución - manual e ingManInst para ingresoManualInstitucion
      id: 10000,
      clave: 'ingManInst',
      nombre: '',
    };
  }

  public static getDomicilioComp(): any {
    return {
      domicilio: this.getDomicilio(),
    };
  }

  public static getDefaultPublicaPrivada(): any {
    return {
      id: null,
      nombre: '',
      id2: null,
      nombre2: '',
    };
  }

  public static getNuevoRegistroAnotacionesIncumplimiento(): any {
    return {
      id: null,
      numeroFolio: '',
      unidadAdministrativa: '',
      funcionarioSolicitante: '',
      fechaSolicitud: '',
      numeroOficio: '',
      plataforma: {},
      otraPlataforma: '',
      otroSubsistema: '',
      subsistema: {},
      anio: '',
      convocatoriaParticipante: '',
      numeroApoyo: '',
      numeroRegistro: '',
      tipoUsuario: '',
      numeroCvu: '',
      descripcion: '',
      evidenciaAnexo: null,
      evidenciaAnexoUrl: '',
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      rfc: null,
      razonSocial: null,
    };
  }

  public static getRolesUsuarioValidos(): any {
    return [
      'ROLE_EXTERNAL_USER',
      'ROLE_OPERATIVO_RENIECYT',
      'ROLE_DIRECCION_RENIECYT',
      'ROLE_OPERATIVO_CONSULTA_RENIECYT',
      'ROLE_REGISTRO_ANOTACIONES',
    ];
  }

  public static getNacionalExtranjeroOptions(): any {
    return [
      { value: 'NACIONAL', text: 'en México' },
      { value: 'EXTRANJERA', text: 'en el extranjero' },
    ];
  }

  public static getBooleanOptions(): any {
    return [
      { value: { id: 'false', nombre: 'No' }, text: 'No' },
      { value: { id: 'true', nombre: 'Si' }, text: 'Sí' },
    ];
  }

  public static getRawBooleanOptions(): any {
    return [
      { value: false, text: 'No' },
      { value: true, text: 'Si' },
    ];
  }

  public static getEsExtranjeroBooleanOptions(): any {
    return [
      { value: false, text: 'Mexicana(o)' },
      { value: true, text: 'Extranjera(o)' },
    ];
  }

  public static getTipoDomicilioOptions(): any {
    return [
      { value: 'URBANO', text: 'Urbano' },
      { value: 'RURAL', text: 'Rural' },
    ];
  }

  public static getTipoInstitucionOptions(): any {
    return [
      { value: { id: '1', nombre: 'Pública' }, text: 'Pública' },
      { value: { id: '2', nombre: 'Privada' }, text: 'Privada' },
      { value: { id: '3', nombre: 'Ambas' }, text: 'Ambas' },
    ];
  }

  public static getTipoEntidadOptions(): any {
    return [
      { value: 'CONACYT', text: 'SECIHTI' },
      { value: 'OTROS', text: 'Otros' },
    ];
  }

  public static getTipoPublicaPrivada(): any {
    return [
      { value: { id: '01', nombre: 'Pública', id2: '01', nombre2: 'Federal' }, text: 'Pública - Federal' },
      { value: { id: '01', nombre: 'Pública', id2: '02', nombre2: 'Estatal' }, text: 'Pública - Estatal' },
      { value: { id: '01', nombre: 'Pública', id2: '03', nombre2: 'Municipal' }, text: 'Pública - Municipal' },
      { value: { id: '02', nombre: 'Privada', id2: '', nombre2: '' }, text: 'Privada' },
    ];
  }

  public static getNombrePlataforma(): any {
    return [
      { value: { id: '1', nombre: 'MIIC' }, text: 'MIIC' },
      { value: { id: '2', nombre: 'SALSA' }, text: 'SALSA' },
      { value: { id: '2', nombre: 'PS' }, text: 'PEOPLESOFT' },
    ];
  }

  public static getNombreSubsistema(): any {
    return [
      { value: { id: '1', nombre: 'FOMIX' }, text: 'FONDOS MIXTOS (FOMIX)' },
      { value: { id: '2', nombre: 'FOSEC' }, text: 'FONDOS SECTORIALES (FOSEC)' },
      {
        value: { id: '2', nombre: 'FORDECYT' },
        text: 'FONDO INSTITUCIONAL DE FOMENTO REGIONAL PARA EL DESARROLLO CIENTÍFICO, TECNOLÓGICO Y DE INNOVACIÓN (FORDECYT)',
      },
    ];
  }

  public static getTipoUsuario(): any {
    return [
      { value: { id: 'RT', nombre: 'Responsable Técnico' }, text: 'Responsable Técnico' },
      { value: { id: 'RA', nombre: 'Responsable Administrativo' }, text: 'Responsable Administrativo' },
    ];
  }

  public static getDemo(): any {
    return {
      nombre: 'defaul',
      tipoPerfil: this.getDefaultCatalogo(),
      preguntas: [],
    };
  }

  public static getCatalogoExtendido(): any {
    return {
      id: null,
      nombre: null,
      clave: null,
      version: null,
    };
  }

  public static getAreaModelo(): any {
    return {
      id: null,
      nombre: null,
      clave: null,
    };
  }

  public static getAreaConocimiento(): AreaConocimiento {
    return {
      area: null,
      campo: null,
      disciplina: null,
      subdisciplina: null,
    };
  }

  public static getDomicilio(): Domicilio {
    return {
      tipoUbicacion: 'NACIONAL',
      codigoPostal: null,
      estado: null,
      municipio: null,
      localidad: null,
      asentamiento: null,
      tipoAsentamiento: null,
      compartir: false,
      tipoDomicilio: 'URBANO',
      tipoVialidadRural: null,
      tipoVialidadUrbano: null,
      nombreVialidad: null,
      exteriorAnterior: null,
      exteriorNumerico: null,
      exteriorAlfanumerico: null,
      interiorNumerico: null,
      interiorAlfanumerico: null,
      requiereDetalle: false,
      tipoReferencia01: null,
      nombreReferencia01: null,
      tipoReferencia02: null,
      nombreReferencia02: null,
      tipoReferencia03: null,
      nombreReferencia03: null,
      descripcion: null,
      administracion: null,
      derechoTransito: null,
      codigo: null,
      origenTramo: null,
      destinoTramo: null,
      cadenamiento: null,
      margen: null,
      pais: null,
      cpExtranjero: null,
      estadoExtranjero: null,
      ciudadExtranjero: null,
      condadoExtranjero: null,
      calleExtranjero: null,
      numeroExtranjero: null,
    };
  }

  public static getInstitucionModel(): any {
    return {
      id: null,
      clave: null,
      nombre: null,
      tipo: null,
      pais: null,
      entidad: null,
      municipio: null,
      nivelUno: null,
      nivelDos: null,
    };
  }

  public static setInstitucion(): any {
    return {
      buscadorInstitucion: '',
      tipoInstitucion: {
        id: '01',
        nombre: 'Nacional',
      },
      publicaPrivada: this.getDefaultPublicaPrivada(),
      pais: this.getDefaultCatalogo(),
      entidad: this.getDefaultCatalogoClave(),
      municipio: this.getDefaultCatalogoClave(),
      institucion: this.getDefaultCatalogoClave(),
      institucionManual: this.getDefaultCatalogoClaveInstitucion(),
    };
  }

  public static getScian(): any {
    return {
      sector: null,
      subsector: null,
      rama: null,
      subrama: null,
      clase: null,
    };
  }

  public static getOcde(): any {
    return {
      sector: null,
      division: null,
      grupo: null,
      clase: null,
    };
  }

  public static getNuevaSolicitud(): any {
    return {
      tipoSolicitante: {
        id: '1',
        nombre: 'Persona moral (Empresa o Institución)',
      },
      sector: null,
      rfc: null,
      tipoInstitucionEmpresa: null,
      nivel: null,
      tipoInstitucionEntidad: null,
      grupoSocial: null,
      especificar: null,
      clasificacion: null,
      figuraJuridica: null,
      razonSocial: null,
      scian: this.getScian(),
      ocde: this.getOcde(),
      areaConocimiento: this.getAreaConocimiento(),
      tamanioEmpresa: null,
      //datos Fiscal
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      actividadPreponderante: null,
    };
  }

  public static getDatosGenerales(): any {
    return {
      rfc: null,
      nombreEmpresa: null, //razonSocial
      nivel: null,
      tipoInstitucionEntidad: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      tipoActividad: null,
      sector: null,
      tipoEmpresa: null,
      tamanioEmpresa: null,
      figuraJuridica: null,
      sectorScian: null,
      ramaScian: null,
      subsectorScian: null,
      claseScian: null,
      sectorOcde: null,
      divisionOcde: null,
      grupoOcde: null,
      area: null,
      campo: null,
      disciplina: null,
      grupoSocial: null,
      especifique: null,
      clasificacion: null,
    };
  }

  public static getRegistro(): Entities.Registro {
    return {
      tipoSolicitudId: null,
      tipoSolicitudNombre: null,
      rfc: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      actividadId: null,
      actividadNombre: null,
      sectorId: null,
      sectorNombre: null,
      razonSocial: null,
      tipoInstitucionId: null,
      tipoInstitucionNombre: null,
      nivelId: null,
      nivelNombre: null,
      figuraJuridicaId: null,
      figuraJuridicaNombre: null,
      grupoSocialId: null,
      grupoSocialNombre: null,
      grupoSocialEspecificar: null,
      clasificacionId: null,
      clasificacionNombre: null,
      tamanioId: null,
      tamanioNombre: null,
      activated: true,
      esMigrado: true,
      noDeRegistro: null,
      noDeRegistroAnterior: null,
    };
  }

  public static getPersona(): Entities.Persona {
    return {
      tipoId: null,
      tipoNombre: null,
      rfc: null,
      curp: null,
      cvu: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      fechaRegistro: null,
      generoId: null,
      generoNombre: null,
      estadoConyugalId: null,
      estadoConyugalNombre: null,
      nacionalidadId: null,
      nacionalidadNombre: null,
      paisNacimientoId: null,
      paisNacimientoNombre: null,
      entidadFederativaId: null,
      entidadFederativaNombre: null,
      activated: true,
    };
  }

  public static getSector(): Entities.Sector {
    return {
      scianSectorId: null,
      scianSectorNombre: null,
      scianSubsectorId: null,
      scianSubsectorNombre: null,
      scianRamaId: null,
      scianRamaNombre: null,
      scianSubramaId: null,
      scianSubramaNombre: null,
      scianClaseId: null,
      scianClaseNombre: null,
      ocdeSectorId: null,
      ocdeSectorNombre: null,
      ocdeDivisionId: null,
      ocdeDivisionNombre: null,
      ocdeGrupoId: null,
      ocdeGrupoNombre: null,
      ocdeClaseId: null,
      ocdeClaseNombre: null,
      areaAreaId: null,
      areaAreaNombre: null,
      areaCampoId: null,
      areaCampoNombre: null,
      areaDisciplinaId: null,
      areaDisciplinaNombre: null,
      areaSubdisciplinaId: null,
      areaSubdisciplinaNombre: null,
      activated: true,
    };
  }

  public static getNuevoRegistro(): Entities.NuevoRegistro {
    return {
      registro: this.getRegistro(),
      persona: this.getPersona(),
      sector: this.getSector(),
    };
  }

  public static getRepresentanteSede() {
    return {
      datosGenerales: this.getdatosGeneralesRepresentanteSede(),
      poderOtorgado: this.getPoderOtorgadoRepresentanteSede(),
      domicilioResidencia: this.getDomicilio(),
      mediosContacto: [],
    };
  }

  public static getdatosGeneralesRepresentanteSede() {
    return {
      curp: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      rfc: null,
      paisNacimiento: null,
      estado: null,
      nacionalidad: null,
      estadoConyugal: null,
      cvu: null,
    };
  }

  public static getPoderOtorgadoRepresentanteSede() {
    return {
      tipoPoder: null,
      poderOtorgado: null,
      fechaExpedicion: null,
      nombreDocumento: null,
      nombrefuncionario: null,
      puestoFuncionario: null,
      estado: null,
      parrafosFacultad: null,
    };
  }

  public static getPoderOtorgado(): Entities.PoderOtorgado {
    return {
      id: null,
      persona_id: null,
      poderOtorgadoNombre: null,
      poderOtorgadoUrl: null,
      poderOtorgadoId: null,
      entidadId: null,
      entidadNombre: null,
      municipioId: null,
      municipioNombre: null,
      localidadId: null,
      localidadNombre: null,
      tipoPoderId: null,
      tipoPoderNombre: null,
      numeroDocumento: null,
      nombreNotario: null,
      numeroNotario: null,
      fechaDocumento: null,
      nombreDocumento: null,
      puestoFuncionario: null,
      facultadRepresentante: null,
    };
  }

  public static getMiPerfil(): MiPerfil {
    return {
      fotografia: undefined,
      semblanza: null,
      mediosContacto: [],
      areaConocimiento: this.getAreaConocimiento(),
      orcId: null,
      researcherIdThomson: null,
      arXivAuthorId: null,
      pubMedAuthorId: null,
      openId: null,
      curp: null,
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
      fechaNacimiento: null,
      sexo: null,
      paisNacimiento: null,
      entidadFederativa: null,
      rfc: null,
      estadoCivil: null,
      nacionalidad: null,
      domicilio: this.getDomicilio(),
      documentoExtranjero: undefined,
      contactosEmergencia: [],
      dependientesEconomicos: [],
    };
  }

  public static modelDocumentoCreacion() {
    return {
      id: null,
      tipoDocumento: {
        id: null,
        nombre: null,
      },
      entidad: {},
      municipio: {},
      localidadId: {},
      ciudad: {},
      numeroActa: null,
      fechaActa: null,
      nombreNotario: null,
      numeroNotario: null,
      folio: null,
      folioConstitucion: null,
      folioPropiedad: null,
      nombreDocumento: null,
      urlDocumento: null,
      puestoFuncionario: null,
      nombreFuncionario: null,
      numeroPoliza: null,
      numeroCorredor: null,
      nombreCorredor: null,
      constitucionLegalDocumento: null,
      denominacionLeyMexicana: null,
      razonSocialAval: null,
      activated: true,
      nombreFideicomisante: null,
      entidadFiduciaria: null,
      numeroReniecytAval: null,
      razonAval: null,
      noRegistro: null,
      razonSocial: null,
    };
  }

  public static getNuevoDocumentoCreacion(): Entities.DocumentoCreacion {
    return {
      tipoDocumentoId: null,
      tipoDocumentoNombre: null,
      entidadId: null,
      entidadNombre: null,
      numeroActa: null,
      fechaActa: null,
      nombreNotario: null,
      numeroNotario: null,
      folio: null,
      nombreDocumento: null,
      urlDocumento: null,
      puestoFuncionario: null,
      constitucionLegalDocumento: null,
      denominacionLeyMexicana: null,
      razonSocialAval: null,
      activated: true,
      folioConstitucion: null,
      folioPropiedad: null,
      nombreFuncionario: null,
      nombreFideicomisante: null,
      entidadFiduciaria: null,
      numeroPoliza: null,
      nombreCorredor: null,
      numeroCorredor: null,
      numeroRegistroAval: null,
    };
  }

  public static getNuevoPoderOtorgado(): Entities.PoderOtorgado {
    return {
      id: null,
      fechaDocumento: null,
      poderOtorgadoId: null,
      poderOtorgadoNombre: null,
      tipoPoderId: null,
      tipoPoderNombre: null,
      entidadId: null,
      entidadNombre: null,
      nombreDocumento: null,
      nombreNotario: null,
      puestoFuncionario: null,
      numeroDocumento: null,
      numeroNotario: null,
      facultadRepresentante: null,
      poderOtorgadoUrl: null,
    };
  }

  public static getSolicitudMoral(): any {
    return {
      noRegistro: null,
      razonSocial: null,
    };
  }

  public static getSolicitudFiscal(): any {
    return {
      razonSocial: null,
    };
  }

  public static getDomicilioReniecyt(): Entities.RegistroDomicilio {
    return {
      id: null,
      registroId: null,
      personaId: null,
      tipoId: null,
      tipoNombre: null,
      codigoPostal: null,
      estadoId: null,
      estadoNombre: null,
      municipioId: null,
      municipioNombre: null,
      localidadId: null,
      localidadNombre: null,
      asentamientoId: null,
      asentamientoNombre: null,
      esCarretera: false,
      esCamino: false,
      tipoCalleId: null,
      tipoCalleNombre: null,
      nombreCalle: null,
      origenTramo: null,
      destinoTramo: null,
      margenId: null,
      margenNombre: null,
      cadenamiento: null,
      numeroExterior: null,
      numeroExteriorAlfanumerico: null,
      numeroExteriorAnterior: null,
      numeroInterior: null,
      numeroInteriorAlfanumerico: null,
      entreCalle1TipoId: null,
      entreCalle1TipoNombre: null,
      entreCalle2TipoId: null,
      entreCalle2TipoNombre: null,
      posteriorTipoId: null,
      posteriorTipoNombre: null,
      posteriorNombre: null,
      descripcionUbicacion: null,
      esExtranjero: false,
      tipoVialidadId: null,
      tipoVialidadNombre: null,
      activated: false,
      tipoAsentamientoId: null,
      tipoAsentamientoNombre: null,
      entreC1Nombre: null,
      entreC2Nombre: null,
    };
  }

  public static getBandejaRepresentanteSede(): any {
    return {
      noRegistro: null,
      razonSocial: null,
    };
  }

  public static getSocio(): Entities.Socio {
    return {
      nombre: null,
      primerApellido: null,
      segundoApellido: null,
    };
  }

  public static getComentario(): any {
    return {
      comentario: null,
    };
  }

  public static getCambioDatos(): any {
    return {
      rfc: null,
      razonSocial: null,
      comentario: null,
    };
  }

  public static getActualizaRegistro(): Entities.ActualizaRegistro {
    return {
      registro: this.getRegistro(),
      sector: this.getSector(),
    };
  }

  public static getEstatusRevision() {
    return { aceptado: 'ACEPTADO', rechazado: 'RECHAZADO' };
  }

  public static guardarValores(isSubSede, idRegistroPadre, estatusRegistroPadre) {
    this.guardarIsSubSede(isSubSede);
    localStorage.setItem('idRegistroPadre', window.btoa(idRegistroPadre));
    localStorage.setItem('estatusRegistroPadre', window.btoa(estatusRegistroPadre));
  }

  public static guardarIsRepresentante(valor: boolean): void {
    localStorage.setItem('isRepresentante', window.btoa(String(valor)));
  }

  public static guardarIsSubSede(valor: boolean): void {
    localStorage.setItem('isSubSede', window.btoa(String(valor)));
  }

  public static guardarProvieneDePersonaFisica(valor: boolean): void {
    localStorage.setItem('provieneDePersonaFisica', window.btoa(String(valor)));
  }

  public static guardarEdicionSolicitudArea(valor: boolean): void {
    localStorage.setItem('edicionSolicitudArea', window.btoa(String(valor)));
  }

  public static guardarProvieneInfoSubsedes(valor: boolean): void {
    localStorage.setItem('provieneInfoSubsedes', window.btoa(String(valor)));
  }

  public static guardarReseteoSede(valor: boolean): void {
    localStorage.setItem('reseteoSede', window.btoa(String(valor)));
  }

  private static obtenerValorDecodificado(clave: string): string | null {
    const valorCodificado = localStorage.getItem(clave);
    if (valorCodificado === null) {
      return null;
    }
    try {
      return window.atob(valorCodificado);
    } catch (error) {
      return null;
    }
  }

  // Método para decodificar y convertir a booleano
  private static obtenerValorDecodificadoBooleano(clave: string): boolean {
    const valorCodificado = localStorage.getItem(clave);
    if (valorCodificado === null) {
      return false; // Valor predeterminado si no existe
    }
    try {
      const valorDecodificado = window.atob(valorCodificado);
      return valorDecodificado === 'true'; // Convierte "true" en `true`, "false" en `false`
    } catch (error) {
      return false;
    }
  }

  private static obtenerValorDecodificadoNombreRepresentante(clave: string): string | null {
    const valorCodificado = localStorage.getItem(clave);
    if (valorCodificado === null) {
      return null;
    }
    try {
      return decodeURIComponent(escape(window.atob(valorCodificado)));
    } catch (error) {
      return null;
    }
  }

  public static obtenerIdRegistroPadre() {
    return this.obtenerValorDecodificado('idRegistroPadre');
  }

  public static obtenerIdRegistro() {
    return this.obtenerValorDecodificado('idRegistro');
  }

  public static obtenerIdSede() {
    return this.obtenerValorDecodificado('idSede');
  }

  public static obtenerIdPersona() {
    return this.obtenerValorDecodificado('idPersona');
  }

  public static obtenerEstatusRegistroPadre() {
    return this.obtenerValorDecodificado('estatusRegistroPadre');
  }

  public static obtenerIsSubSede() {
    return this.obtenerValorDecodificadoBooleano('isSubSede');
  }

  public static obtenerIsRepresentante() {
    return this.obtenerValorDecodificadoBooleano('isRepresentante');
  }

  public static obtenerTipoPersona() {
    return this.obtenerValorDecodificado('tipoPersona');
  }

  public static obtenerIdPersonaPadre() {
    return this.obtenerValorDecodificado('idPersonaPadre');
  }

  public static obtenerCvuPersona() {
    return this.obtenerValorDecodificado('cvuPersona');
  }

  public static obtenerProvieneDePersonaFisica() {
    return this.obtenerValorDecodificadoBooleano('provieneDePersonaFisica');
  }

  public static obtenerNombreRepresentante() {
    return this.obtenerValorDecodificadoNombreRepresentante('nombreRepresentante');
  }

  public static obtenerEdicionSolicitudArea() {
    return this.obtenerValorDecodificadoBooleano('edicionSolicitudArea');
  }

  //Indica si viene de la bandeja de secciones de subsedes "Consulta Subsedes"
  public static obtenerProvieneInfoSubsedes() {
    return this.obtenerValorDecodificadoBooleano('provieneInfoSubsedes');
  }

  public static obtenerReseteoSede() {
    return this.obtenerValorDecodificadoBooleano('reseteoSede');
  }

  // Elimina los valores del localStorage
  public static eliminarValoresSubSedes() {
    localStorage.removeItem('isSubSede');
    localStorage.removeItem('idRegistroPadre');
  }

  public static eliminarIdRegistro() {
    localStorage.removeItem('idRegistro');
  }

  public static eliminarIsRepresentante() {
    localStorage.removeItem('isRepresentante');
  }

  public static eliminarIdPersona() {
    localStorage.removeItem('idPersona');
  }

  public static eliminarTipoPersona() {
    localStorage.removeItem('tipoPersona');
  }

  public static eliminarIdPersonaPadre() {
    localStorage.removeItem('idPersonaPadre');
  }

  public static eliminarCvuPersona() {
    localStorage.removeItem('cvuPersona');
  }

  public static eliminarProvieneDePersonaFisica() {
    localStorage.removeItem('provieneDePersonaFisica');
  }

  public static eliminarNombreRepresentante() {
    localStorage.removeItem('nombreRepresentante');
  }

  public static eliminarEdicionSolicitudArea() {
    localStorage.removeItem('edicionSolicitudArea');
  }

  public static eliminarProvieneInfoSubsedes() {
    localStorage.removeItem('provieneInfoSubsedes');
  }

  public static eliminarReseteoSede() {
    localStorage.removeItem('reseteoSede');
  }

  public static eliminaVariablesStore() {
    this.eliminarIdRegistro();
    this.eliminarValoresSubSedes();
    this.eliminarIsRepresentante();
    this.eliminarIdPersona();
    this.eliminarTipoPersona();
    localStorage.removeItem('estatusRegistroPadre');
    this.eliminarIdPersonaPadre();
    this.eliminarCvuPersona();
    this.eliminarProvieneDePersonaFisica();
    this.eliminarNombreRepresentante();
    this.eliminarEdicionSolicitudArea();
    this.eliminarProvieneInfoSubsedes();
    this.eliminarReseteoSede();
    localStorage.removeItem('idSede');
  }

  public static getComentarioTemporal(): any {
    return {
      comentario: null,
    };
  }

  public static saveComentarioTemporal(): Entities.ComentarioRegistroEstatus {
    return {
      id: null,
      registroEstatusId: null,
      comentario: null,
    };
  }

  public static getFile(): any {
    return {
      contentType: null,
      content: null,
      nombre: null,
      size: null,
      uri: null,
    };
  }

  public static getDatosEliminacionSubsede(): Entities.DatosEliminacionSubsede {
    return {
      id: null,
      idRegistro: null,
      comentario: null,
      nombreDocumento: null,
      nombreDocumentoDos: null,
      urlDocumento: null,
      urlDocumentoDos: null,
      cvuUsuario: null,
      nombreUsuario: null,
      esAdmin: null,
    };
  }

  public static getRegistroCancelacionIncumplimiento(): Entities.RegistroCancelacionIncumplimiento {
    return {
      unidadAdministrativa: '',
      funcionarioSolicitante: '',
      fechaSolicitud: '',
      numeroOficio: '',
      justificacionCumplimiento: '',
    };
  }

  public static saveDocumentoCancelacionIncumplimiento(): Entities.DocumentoCancelacionIncumplimiento {
    return {
      nombreArchivo: '',
      url: '',
      activated: true,
    };
  }
}
